import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📦 AMIGURUMI BUSINESS PACK™',
  ideal: 'Tejedoras y emprendedoras que quieren vivir de sus amigurumis sin regalar su trabajo ni vender barato',
  was: '$54.990 ARS',
  now: '$19.990 ARS',
  features: ['📚 12 Tomos completos de técnica y ventas', '🧮 Sistema de precios anti-inflación garantizado', '📸 Calculadora de costos con margen real incluida', '🗺️ Hoja de ruta: de cero a primera venta en 30 días', '📱 Meta Ads Express para tejedoras ARG', '🎁 5 Bonos estratégicos gratis ($46.500 de valor)', '🛡️ Garantía 7 días sin preguntas'],
  cta: 'Quiero el Amigurumi Business Pack — $19.990 ARS'
};
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-120" data-mp="3w1jgq4n1knzw">
      <div className="mx-auto max-w-5xl px-5 pb-6 pt-5" data-id="element-121" data-mp="4rugta8ktw5v">
        <div className="mx-auto flex w-full max-w-xl flex-col items-stretch gap-6" data-id="element-122" data-mp="9sia62ka2p39">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5
        }} className="relative flex w-full flex-col items-center rounded-3xl border border-plata/40 bg-ink-2 px-7 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(168,56,74,0.55)]" data-id="element-123" data-mp="erbm3qjx281b">
            <h3 className="font-display text-lg font-black text-plata-soft" data-id="element-124" data-mp="3rxlidw5jjh7w">{plan.name}</h3>
            <p className="mt-2 text-sm text-white/60" data-id="element-125" data-mp="2uihcnwik05yh">
              <span className="font-semibold text-white/80" data-id="element-126" data-mp="2uhy4v8mmaxy6">Ideal para:</span> {plan.ideal}
            </p>

            <div className="mt-6" data-id="element-127" data-mp="2zfpxy5z00q3y">
              <span className="text-base font-medium text-white/40 line-through" data-id="element-128" data-mp="2rguxj7e7tkak">{plan.was}</span>
              <div className="font-display text-4xl font-black text-silver-shine" data-id="element-129" data-mp="2mhrxk1d3e49g">{plan.now}</div>
              <p className="mt-1 text-xs font-semibold text-plata" data-id="element-130" data-mp="316o9i9i9s1fc">
                Pago único · Acceso de por vida
              </p>
            </div>

            <p className="mt-6 w-full text-left text-sm font-bold text-white" data-id="element-131" data-mp="2w83aueio1pt0">
              ✅ Tu acceso completo incluye:
            </p>
            <ul className="mt-3 w-full flex-1 space-y-3 text-left" data-id="element-132" data-mp="23ixewhaicjo0">
              {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-133" data-mp="2ifww8wv5vqvo">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-bordo-light" strokeWidth={3} aria-hidden="true" data-id="element-134" data-mp="2dh3h70087rte" />
                  {f}
                </li>)}
            </ul>

            <div className="mt-7 w-full" data-id="element-135" data-mp="3ovz6rh0evdoq">
              <CTAButton size="md" variant="bordo" className="w-full" data-id="element-136" data-mp="9udy4r1spjr">
                {plan.cta}
              </CTAButton>
            </div>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-137" data-mp="5b1k5zdjlgob">
              {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-138" data-mp="3rhgbdfn6bvs6">
                  <Icon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-139" data-mp="j0lhuqs9nnqr" />
                  {label}
                </span>)}
            </div>
          </motion.div>
        </div>

        <div className="mx-auto mt-8 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-plata/30 bg-white/5 p-5 text-left" data-id="element-140" data-mp="a934soqm9o1w">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-bordo-light" aria-hidden="true" data-id="element-141" data-mp="e8loxiam5v3o" />
          <p className="text-sm leading-relaxed text-white/75" data-id="element-142" data-mp="11y65xvn7iiab">
            <span className="font-bold text-white" data-id="element-143" data-mp="16qpkovxmrjgp">Garantía de devolución de 7 días.</span> Si abrís
            los tomos y en la primera semana sentís que no vale lo que pagaste, pedís el reembolso y
            te devolvemos el 100%. Sin formularios, sin drama, sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}